import React from 'react'
import styled from '@emotion/styled'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {SCORE_RATING_SQUARED_HEIGHT} from '@vio/atlas/experimental/ScoreRatingSquared'
import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'
import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

import {ReviewSummaryWrapper, SentimentTagsWrapper} from './styles'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s200};
`

// The loaded rating row is as tall as its score badge, so reserve that height
// here to keep the first fold from shifting when the rating arrives.
const SquaredRatingRow = styled.div`
  display: flex;
  align-items: center;
  height: ${SCORE_RATING_SQUARED_HEIGHT}px;
`
export const ReviewSummaryLoading = () => {
  const {isMobile} = useDeviceLayout()
  const toggle = useToggle()

  if (isMobile)
    return toggle(
      '90ef358d-ap-first-fold-improvement-v2',
      <ReviewSummaryWrapper>
        <SentimentTagsWrapper>
          <Box gap="s300" display="flex" alignItems="flex-start">
            <SkeletonLoader width={113} marginTop={0} />
          </Box>
        </SentimentTagsWrapper>
      </ReviewSummaryWrapper>,
      <Box paddingTop="s400" paddingBottom="s600">
        <SquaredRatingRow>
          <SkeletonLoader width={96} marginTop={0} />
        </SquaredRatingRow>
      </Box>
    )

  return (
    <Wrapper>
      <SkeletonLoader width={118} marginTop={0} />
    </Wrapper>
  )
}
